export const ACTIONS = {
  CONFIRM_EMAIL: 'CONFIRM_EMAIL',
  CONFIRM_EMAIL_START: 'CONFIRM_EMAIL_START',
  CONFIRM_EMAIL_SUCCESS: 'CONFIRM_EMAIL_SUCCESS',
  CONFIRM_EMAIL_FAILURE: 'CONFIRM_EMAIL_FAILURE',
  CONFIRM_EMAIL_RESET: 'CONFIRM_EMAIL_RESET',
};
